// Environment check: LOCAL, STAGING, SANDBOX, PRODUCTION
export const isLocal: boolean = process.env.ENV === 'local'
export const isStaging: boolean = process.env.ENV === 'staging'
export const isSandbox: boolean = process.env.ENV === 'sandbox'
export const isProduction: boolean = process.env.ENV === 'production'

// Environment check: jest
export const isTestEnvironment = process.env.NODE_ENV === 'jest'
